/**
 * Frontend API client types — narrow types specific to the fetch client wrapper
 * (`ApiError`, `ProblemDetails` parsing, pagination wrapper, fetch options).
 *
 * Wire-format request/response DTOs (BootstrapResponse, DeckResponse, QueueItemDto, ...) live in
 * `apps/web/src/api/endpoints/*`. Generated counterparts in `@fiszki/shared-contracts` (from
 * `apps/api/openapi.json` via @hey-api/openapi-ts, refreshed by `Fiszki.Tests.OpenApi.OpenApiDumpTests`)
 * are intentionally less strict than the hand-rolled aliases — the WebJobs OpenAPI extension does
 * not emit `required` markers and collapses string enums to `string`. Endpoint clients keep
 * hand-rolled types that narrow these to literal unions; the generated types are imported only
 * where the extra precision is not load-bearing.
 */

/** RFC 7807 ProblemDetails — zwracane przez backend ExceptionHandlingMiddleware. */
export interface ProblemDetails {
  type?: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
  traceId?: string;
  /** Field validation errors — `{ "username": ["too_short", "invalid_chars"] }` */
  errors?: Record<string, string[]>;
}

/** Custom error class — thrown przez fetchJson/postJson when backend returns 4xx/5xx. */
export class ApiError extends Error {
  public readonly status: number;
  public readonly problem: ProblemDetails;
  public readonly fieldErrors?: Record<string, string[]>;

  constructor(problem: ProblemDetails) {
    super(problem.detail ?? problem.title);
    this.name = 'ApiError';
    this.status = problem.status;
    this.problem = problem;
    this.fieldErrors = problem.errors;
  }
}

/** Pagination wrapper dla list endpoints. */
export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

/** Options dla fetch wrappera. */
export interface FetchOptions extends RequestInit {
  /** Suppress global toast on error (caller obsługuje sam). */
  suppressErrorToast?: boolean;
  /** Override timeout w ms (default 30s). */
  timeoutMs?: number;
}
